<template>
  <div class="marketing-wysiwyg">
    <VueEditor :value="value" :editorToolbar="editorToolbar" @input="$emit('input', $event)" />
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor"

export default {
  name: "MarketingWysiwyg",
  components: { VueEditor },
  props: {
    value: {
      type: String,
      default: "",
    },
    editorToolbar: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.marketing-wysiwyg {
  margin: 0.875rem 0;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 0.8125rem;
  color: #f4f4f5;
  background: #171719;
  font-size: 1rem;
}

.marketing-wysiwyg ::v-deep .quillWrapper {
  background: transparent;
}

.marketing-wysiwyg ::v-deep .ql-toolbar.ql-snow {
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  color: #d4d4d8;
  background: #242426;
}

.marketing-wysiwyg ::v-deep .ql-container.ql-snow {
  border: 0;
  color: #f4f4f5;
  background: #171719;
  font-family: inherit;
  font-size: 1rem;
}

.marketing-wysiwyg ::v-deep .ql-editor {
  min-height: 13rem;
  max-height: 32rem;
  overflow-y: auto;
  color: #f4f4f5;
  background: #171719;
  line-height: 1.65;
}

.marketing-wysiwyg ::v-deep .ql-editor.ql-blank::before {
  color: #8f9095;
  font-style: normal;
}

.marketing-wysiwyg ::v-deep .ql-editor a {
  color: #72dfa0;
}

.marketing-wysiwyg ::v-deep .ql-editor::selection,
.marketing-wysiwyg ::v-deep .ql-editor *::selection {
  color: #ffffff;
  background: rgba(0, 150, 64, 0.55);
}

.marketing-wysiwyg ::v-deep .ql-toolbar button,
.marketing-wysiwyg ::v-deep .ql-toolbar .ql-picker-label,
.marketing-wysiwyg ::v-deep .ql-toolbar .ql-picker-item {
  color: #d4d4d8;
  font-size: 0.875rem;
}

.marketing-wysiwyg ::v-deep .ql-snow .ql-stroke {
  stroke: #d4d4d8;
}

.marketing-wysiwyg ::v-deep .ql-snow .ql-fill,
.marketing-wysiwyg ::v-deep .ql-snow .ql-stroke.ql-fill {
  fill: #d4d4d8;
}

.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar button:hover,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar button.ql-active,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar .ql-picker-label:hover,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar .ql-picker-label.ql-active,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar .ql-picker-item:hover,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar .ql-picker-item.ql-selected {
  color: #58d388;
}

.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar button:hover .ql-stroke,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar button.ql-active .ql-stroke,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke {
  stroke: #58d388;
}

.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar button:hover .ql-fill,
.marketing-wysiwyg ::v-deep .ql-snow.ql-toolbar button.ql-active .ql-fill {
  fill: #58d388;
}

.marketing-wysiwyg ::v-deep .ql-snow .ql-picker-options {
  border-color: rgba(255, 255, 255, 0.14);
  color: #f4f4f5;
  background: #29292c;
  box-shadow: 0 1rem 2.5rem rgba(0, 0, 0, 0.4);
}

.marketing-wysiwyg ::v-deep .ql-snow .ql-tooltip {
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #f4f4f5;
  background: #29292c;
  box-shadow: 0 1rem 2.5rem rgba(0, 0, 0, 0.4);
}

.marketing-wysiwyg ::v-deep .ql-snow .ql-tooltip input[type="text"] {
  min-height: 2.5rem;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 0.5rem;
  color: #ffffff;
  background: #171719;
  font-size: 0.875rem;
}

@media (max-width: 37.4375rem) {
  .marketing-wysiwyg ::v-deep .ql-editor {
    min-height: 10rem;
    max-height: 24rem;
  }
}
</style>
